import Model from '@/models/Model'

export default class GUserSeller extends Model {
    resource() {
        return 'g_user_seller'
    }
}
